import { useNavigate } from 'react-router-dom'
import { List } from '@mui/material'

import { RouteItem } from './route-item.component'

import { useStyles } from './styles'

interface IProps {
  items: { primary: string; link: string }[]
}

export const RoutesButtons = ({ items }: IProps) => {
  const classes = useStyles()
  const navigate = useNavigate()

  const handleNavigate = (link: string) => () => {
    navigate(link)
  }

  return (
    <List className={classes.itemsWrapper} disablePadding>
      {items.map((item) => (
        <RouteItem
          key={item.primary}
          primary={item.primary}
          handleNavigate={handleNavigate(item.link)}
        />
      ))}
    </List>
  )
}
